import { NumberInput, required, TextInput, BooleanInput, useTranslate } from 'react-admin';
import { Box, Stack, Typography } from '@mui/material';
import { DailyPrizePoolConfig, PoolType } from '../../../services/redpacketService';

interface FormProps {
  isCreate?: boolean;
  poolType: PoolType;
  config?: DailyPrizePoolConfig;
}

const DailyPrizePoolForm = (props: FormProps) => {
  const { isCreate, poolType, config } = props;
  const t = useTranslate();

  const numberProps = {
    parse: (v: any) => (v === '' || v == null ? undefined : Number(v)),
    format: (v: any) => (v == null ? '' : v),
    inputProps: {
      inputMode: 'decimal',
      step: 'any',
      onWheel: (e: React.WheelEvent<HTMLInputElement>) => {
        (e.currentTarget as HTMLInputElement).blur();
      },
    } as const,
  } as const;

  const hourChoices = Array.from({ length: 24 }, (_v, index) => ({
    id: index,
    name: `${index}:00`,
  }));

  return (
    <Stack spacing={3} gap={2}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.poolTypeLabel')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="body1">
            {poolType === PoolType.SHARED ? t('module.redpacket.sharedPoolName') : t('module.redpacket.criticalHitPoolName')}
          </Typography>
        </Box>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.dailyBudget')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <NumberInput
            label={false}
            source="dailyBudget"
            validate={[required()]}
            placeholder={t('module.redpacket.dailyBudgetPlaceholder')}
            fullWidth
            defaultValue={config?.dailyBudget}
            {...numberProps}
          />
        </Box>
      </Stack>

      {isCreate && (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.resetHourUtc')}
        </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <NumberInput
              label={false}
              source="resetHourUTC"
              validate={[required()]}
              placeholder={t('module.redpacket.resetHourPlaceholder')}
              fullWidth
              defaultValue={config?.resetHourUTC ?? 0}
              {...numberProps}
              inputProps={{ min: 0, max: 23 }}
            />
          </Box>
        </Stack>
      )}
      {isCreate && (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.isActive')}
        </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <BooleanInput label="" source="isActive" defaultValue={config?.isActive ?? true} />
          </Box>
        </Stack>
      )}

      {isCreate && (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.description')}
        </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <TextInput
              label={false}
              source="description"
              placeholder={t('module.redpacket.description')}
              fullWidth
              defaultValue={config?.description}
              multiline
              rows={3}
            />
          </Box>
        </Stack>
      )}
    </Stack>
  );
};

export default DailyPrizePoolForm;
